import { Spin } from 'antd';
import React, { Suspense } from 'react';
import { useLocation } from 'react-router-dom';
import { AuthenticationWrap, OAuthAuthenticationWrap } from './overview/style';

const AuthLayout = (WraperContent) => {
  return function AuthLayoutInner() {
    const location = useLocation();
    const isOAuthConsent = location.pathname.startsWith('/oauth/consent');
    const Wrapper = isOAuthConsent ? OAuthAuthenticationWrap : AuthenticationWrap;

    return (
      <Suspense
        fallback={
          <div className="spin">
            <Spin />
          </div>
        }
      >
        <Wrapper className='login-bg-section'>
          <div className="ninjadash-authentication-wrap">
            <div className="ninjadash-authentication-brand">
              {/* <img src={require(`../../../static/img/logo_dark.svg`).default} alt="" /> */}
              {/* <img src={require(`../../../static/img/logo_dark.png`)} alt="" height="64" /> */}
              <img src={require(`../../../static/img/new_logo_hg.png`)} alt="" height="115" />
            </div>
            <WraperContent />
          </div>
        </Wrapper>
      </Suspense>
    );
  };
};

export default AuthLayout;
